<template>
  <div class="pdf-redacting-sidebar-type">
    <v-radio-group v-model="redactType" hide-details>
      <app-button
        v-for="option in redactTypeOptionsValues"
        :key="`option-${option}`"
        :disabled="option === REDACT_TYPE_OPTIONS.KEYWORDS"
        class="mb-1 d-flex justify-space-between align-center"
        style="padding: 10px 12px;"
        type="ghost"
        @click="redactType = option"
      >
        <template v-if="option === REDACT_TYPE_OPTIONS.KEYWORDS">
          <app-icon-ds
            icon="file-magnifying-glass"
            weight="fal"
            size="sm"
          />
          <p class="text--small text--regular mb-0">
            {{ $t('common.PdfRedactingSidebar.redactByKeywords') }}
          </p>
          <AppFeatureTag tag="upcoming" />
        </template>

        <!-- ZONE -->
        <template v-else>
          <img
            class="ml-1"
            :src="getRedactByKeywordsIcon"
            height="18"
            width="18"
            alt="Icon"
          />
          <p class="text--small text--regular mb-0">
            {{ $t('common.PdfRedactingSidebar.redactByZone') }}
          </p>
        </template>
      </app-button>
    </v-radio-group>
  </div>
</template>

<script>
  import AppFeatureTag from '@/common/AppFeatureTag.vue'
  import { REDACT_TYPE_OPTIONS } from '@/common/utils/redactTypes.ts'

  export default {
    name: 'PdfRedactingSidebarType',
    props: {
      defaultRedactType: {
        required: true,
        validator: (value) => {
          return value === null || typeof value === 'string'
        },
      },
    },
    components: {
      AppFeatureTag,
    },
    data () {
      return {
        redactType: null,
        REDACT_TYPE_OPTIONS,
      }
    },
    computed: {
      redactTypeOptionsValues () {
        return Object.values(REDACT_TYPE_OPTIONS)
      },
      getRedactByKeywordsIcon () {
        return new URL(`../../assets/img/redact-by-keywords.svg`, import.meta.url).href
      },
    },
    watch: {
      redactType (value) {
        this.$emit('change-redact-type', value)
      },
    },
  }
</script>

<style lang="scss">
  @import "vuetify/settings";
  .pdf-redacting-sidebar-type {
    .v-selection-control-group {
      width: 100%;
    }
  }
</style>
